import { CalendarDays, ListTodo } from "lucide-react";

import { Row } from "@/components/Row";
import { Text } from "@/components/Text";
import { Button } from "@/components/ui/button";

import { mixpanelUtils } from "@/lib/mixpanel/mixpanel";
import { MIXPANEL_SCREENS } from "@/lib/mixpanel/types";
import { cn } from "@/lib/utils";
import { DashboardSchedulePanelView } from "@/types";

export const DashboardSchedulePanelViewToggle = ({
  value,
  onChange,
}: {
  value: DashboardSchedulePanelView;
  onChange: (value: DashboardSchedulePanelView) => void;
}) => {
  const handleChange = (next: DashboardSchedulePanelView) => {
    if (next === value) {
      return;
    }
    mixpanelUtils.trackButtonClick(
      next === DashboardSchedulePanelView.CALENDAR
        ? "Show schedule calendar"
        : "Show schedule tasks",
      MIXPANEL_SCREENS.DASHBOARD,
    );
    onChange(next);
  };

  const renderOption = (
    option: DashboardSchedulePanelView,
    label: string,
    Icon: typeof CalendarDays,
  ) => (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      onClick={() => {
        handleChange(option);
      }}
      className={cn(
        "h-8 gap-1.5 rounded-full px-2.5 text-slate-500",
        value === option && "bg-sky-100 text-sky-700 hover:bg-sky-100",
      )}
    >
      <Icon className="h-3.5 w-3.5 shrink-0" />
      <Text
        className={cn(
          "text-xs font-medium",
          value === option ? "text-sky-700" : "text-slate-500",
        )}
      >
        {label}
      </Text>
    </Button>
  );

  const render = () => (
    <Row className="items-center gap-0.5 rounded-full border border-slate-200 bg-white p-0.5">
      {renderOption(
        DashboardSchedulePanelView.CALENDAR,
        "Calendar",
        CalendarDays,
      )}
      {renderOption(DashboardSchedulePanelView.TASKS, "Tasks", ListTodo)}
    </Row>
  );

  return render();
};
